export interface ColorObject {
    color: string;
    backgroundColor: string;
}

export const colorsArray: ColorObject[] = [
    {
        color: '#9254DE',
        backgroundColor: '#F9F0FF',
    },
    {
        color: '#FF7A45',
        backgroundColor: '#FFF2E8',
    },
    {
        color: '#40A9FF',
        backgroundColor: '#E6F7FF',
    },
    {
        color: '#F759AB',
        backgroundColor: '#FFF0F6',
    },
    {
        color: '#52C41A',
        backgroundColor: '#F6FFED',
    },
    {
        color: '#597EF7',
        backgroundColor: '#F0F5FF',
    },
];

/**
 * Generate a hash code from a string
 */
export const getHashCode = (string: string): number => {
    let hashCode = 0;
    if (string.length === 0) return hashCode;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < string.length; i++) {
        const char = string.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hashCode = (hashCode << 5) - hashCode + char;
        // eslint-disable-next-line no-bitwise
        hashCode |= 0; // Convert to 32bit integer
    }

    return hashCode;
};

/**
 * Get a color object based on a string (for consistent avatar colors)
 */
export const getColor = (string: string): ColorObject => {
    const hashCode = getHashCode(string);
    const index = Math.abs(hashCode) % colorsArray.length;
    const assignedColorObject = colorsArray[index];

    return assignedColorObject;
};

/**
 * Extract initials from a full name
 */
export const getNameAbbreviation = (fullName: string): string => {
    if (!fullName) return '';

    const words = fullName.trim().split(' ');
    const firstLetter = words[0]?.charAt(0) || '';
    const secondLetter = words[1]?.charAt(0) || '';

    return `${firstLetter}${secondLetter}`;
};
